<template>
  <AppWithLoading v-slot:default="{loader}">
    <VForm v-model="isValid" v-scroll-to-first-error @submit.p.prevent="loader(() => submitPrevent())">
      <VRow>
        <VCol>
          <VTextField
            id="email"
            v-model="email"
            :error-messages="profileError.errors.email"
            outlined
            dense
            type="email"
            autocomplete="email"
            @input="profileError.errors.email = null"
          >
            <template v-slot:label>
              {{ $t('email') }} <span class="red--text">*</span>
            </template>
          </VTextField>
        </VCol>
      </VRow>
      <VAlert
        v-if="hasErrorMessageOnly && firstErrorMessage"
        type="alert"
        class="my-8"
      >
        {{ firstErrorMessage }}
      </VAlert>
      <AppWithLoading v-slot:default="{loader}">
        <VBtn
          color="success"
          :disabled="!isSubmitButtonEnabled"
          @click="loader(() => submit())"
        >
          {{ $t('continue') }}
        </VBtn>
      </AppWithLoading>
    </VForm>
  </AppWithLoading>
</template>
<script>
import ScrollToFirstError from '../directives/ScrollToFirstError';
import AppWithLoading from '../components/AppWithLoading.vue';
import ApiMixin from '../mixins/ApiMixin';

export default {
  name: 'TestCandidateEmailForm',
  components: { AppWithLoading },
  directives: { ScrollToFirstError },
  mixins: [ApiMixin],
  props: {
    candidate: {
      type: Object,
      required: true,
      validator: prop => typeof prop === 'object' || prop === null,
    },
  },
  data() {
    return {
      isValid: false,
      email: null,
      personalDataCheckbox: false,
      profileError: this.getInitialErrorData(),
    };
  },
  computed: {
    isSubmitButtonEnabled() {
      return this.isValid
        && this.email;
      // todo: убраать если не будет нужно
      // && this.personalDataCheckbox;
    },
    hasErrorMessageOnly() {
      return !Object.keys(this.profileError.errors).length && this.profileError.errorMessage;
    },
    firstErrorMessage() {
      return this.profileError.errorMessage;
    },
  },
  methods: {
    getInitialErrorData() {
      return {
        errorMessage: null,
        errors: {},
      };
    },
    async submit() {
      await this.finishTestInterview();
      this.$emit('done');
    },
    async submitPrevent() {
      if (this.isSubmitButtonEnabled) {
        await this.submit();
      }
    },
    async finishTestInterview() {
      await this.withApiErrorHandling(async () => this.$store.dispatch('candidate/updateTestEmail', {
        candidateId: this.candidate.id,
        params: { email: this.email },
      }), 'profileError');
    },
  },
};
</script>

<style scoped>

</style>

<i18n locale='en' lang='yaml'>
email: Email
permission: I consent to the storage and processing of my
personalData: personal data
continue: Continue
</i18n>

<i18n locale='ru' lang='yaml'>
email: Email
permission: Я даю согласие на хранение и обработку моих
personalData: персональных данных
continue: Далее
</i18n>
